import { render, staticRenderFns } from "./GameDataView.vue?vue&type=template&id=df0aa0be&"
import script from "./GameDataView.vue?vue&type=script&lang=js&"
export * from "./GameDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports